
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "StepperItems",
})
export default class StepperItems extends Vue {

}
